import React from 'react';
import { useTranslation } from 'react-i18next';

interface GuidanceSection {
  heading: string;
  body: string;
  items: string[];
}

/** The shul Guidance tab: how the year set-up and the day rules work (Phase 6, docs/day-types-spec.md). */
export default function AdminGuidance() {
  const { t } = useTranslation();
  const sections = t('guidance.sections', { returnObjects: true }) as GuidanceSection[];

  return (
    <div className="space-y-4">
      <div className="rounded-[16px] border border-ink/10 bg-paper p-4 space-y-3">
        <h3 className="text-sm font-semibold text-ink">{t('guidance.title')}</h3>
        <p className="text-sm text-ash">{t('guidance.intro')}</p>
      </div>

      {Array.isArray(sections) &&
        sections.map((section) => (
          <div key={section.heading} className="rounded-[16px] border border-ink/10 bg-paper p-4 space-y-3">
            <h3 className="text-sm font-semibold text-ink">{section.heading}</h3>
            {section.body && <p className="text-sm text-ash">{section.body}</p>}
            <ul className="list-disc ps-5 space-y-1.5 text-sm text-ink">
              {section.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
    </div>
  );
}
